import React from 'react';
import { motion } from 'framer-motion';
interface HowItWorksProps {
  language: 'en' | 'es';
}
export function HowItWorks({
  language
}: HowItWorksProps) {
  const t = {
    en: {
      eyebrow: 'HOW IT WORKS',
      heading: "Renting Is Simple. That's The Point.",
      steps: [{
        num: '01',
        title: 'CONTACT US',
        desc: 'Call, text, or fill out our quote form. We respond fast.'
      }, {
        num: '02',
        title: 'CHOOSE RENTAL',
        desc: "Not sure what you need? We'll help you figure it out."
      }, {
        num: '03',
        title: 'DELIVERY & SETUP',
        desc: 'We bring your rental to your location, clean and ready.'
      }, {
        num: '04',
        title: 'PICKUP SIMPLE',
        desc: "When your rental ends, we come get it. You don't lift a finger."
      }]
    },
    es: {
      eyebrow: 'CÓMO FUNCIONA',
      heading: 'Rentar Es Simple. Ese Es El Punto.',
      steps: [{
        num: '01',
        title: 'CONTÁCTANOS',
        desc: 'Llama, envía un texto o llena nuestro formulario. Respondemos rápido.'
      }, {
        num: '02',
        title: 'ELIGE TU RENTA',
        desc: '¿No estás seguro de lo que necesitas? Te ayudamos a decidir.'
      }, {
        num: '03',
        title: 'ENTREGA E INSTALACIÓN',
        desc: 'Llevamos tu renta a tu ubicación, limpia y lista.'
      }, {
        num: '04',
        title: 'RECOGIDA FÁCIL',
        desc: 'Cuando termina tu renta, la recogemos. No mueves un dedo.'
      }]
    }
  };
  const text = t[language];
  return <section className="py-12 md:py-20 bg-darkBg w-full overflow-hidden" data-id="element-171">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172">
        <div className="text-center mb-10 md:mb-16" data-id="element-173">
          <span className="font-montserrat text-gold text-xs md:text-sm font-bold tracking-widest uppercase mb-3 md:mb-4 block" data-id="element-174">
            {text.eyebrow}
          </span>
          <h2 className="font-oswald text-3xl sm:text-4xl md:text-5xl font-bold text-warmWhite uppercase" data-id="element-175">
            {text.heading}
          </h2>
        </div>

        <div className="relative" data-id="element-176">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-8 left-0 w-full h-0.5 bg-steel" data-id="element-177">
            <div className="absolute top-0 left-0 h-full bg-gold w-full" data-id="element-178"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-6 relative z-10" data-id="element-179">
            {text.steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="text-center" data-id="element-180">
                <div className="mx-auto w-16 h-16 rounded-full bg-carbon border-4 border-gold flex items-center justify-center font-oswald text-2xl font-bold text-warmWhite mb-6" data-id="element-181">
                  {step.num}
                </div>
                <h3 className="font-montserrat text-gold font-bold text-base mb-3 tracking-wide" data-id="element-182">
                  {language === 'es' ? 'PASO' : 'STEP'} {step.num}: {step.title}
                </h3>
                <p className="font-inter text-gray-400 leading-relaxed text-sm md:text-base px-2" data-id="element-183">
                  {step.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}